import {
  SocialIconFacebook,
  SocialIconTwitter,
  SocialIconLinkedIn,
  SocialIconWhatsApp,
} from '../assets/assets';

const socialIcons = {
  facebook: SocialIconFacebook,
  twitter: SocialIconTwitter,
  linkedin: SocialIconLinkedIn,
  whatsapp: SocialIconWhatsApp,
};

export default function generateShareIcon(platform) {
  return socialIcons[platform.toLowerCase()];
}
